import React, { useState, useEffect } from 'react';

const Darkmode = () => {
    const [isLight, setIsLight] = useState(false);
    useEffect(() => {
        setIsLight(document.body.classList.contains("light"));
    }, []);
    const switchTheme = () => {
        document.body.classList.toggle("light");
        setIsLight(document.body.classList.contains("light"));
    };
    return (
        <button type="button" id="darkmode" aria-label="Toggle color theme" aria-pressed={isLight} onClick={switchTheme}>
           <img className="light-icon" src={`${process.env.PUBLIC_URL}/images/icons/sun-01.svg`} alt="Sun icon for light mode" />
           <img className="dark-icon" src={`${process.env.PUBLIC_URL}/images/icons/vector.svg`} alt="Moon icon for dark mode" />
        </button>
    )
}
export default Darkmode;
